import React from "react";
import styled from "styled-components/macro";
import { Popup } from "semantic-ui-react";
import { PopUpItem } from "./PopUpItem";
import handle from "../../images/unit/handle.svg";

const UnitBox = ({
  onPopupOpen,
  onPopupClose,
  popupItem,
  quantity,

  item,
  colorUnit,
  isSticker,
}) => {
  const {
    size,
    color,
    gradientColor,
    unitImage,
    image,
    frameColor = "#FFFFFF",
    showDoor = true,
  } = item;

  return (
    <Popup
      disabled={!image}
      position="right center"
      on="click"
      onOpen={onPopupOpen}
      onClose={onPopupClose}
      trigger={
        <Box style={{ cursor: "pointer" }}>
          <div>
            <Box style={{ flexDirection: "row" }}>
              <Wrapper frameColor={colorUnit || frameColor} size={size}>
                <InnerWrapper
                  showDoor={showDoor}
                  color={color}
                  gradientColor={gradientColor}
                >
                  <Shelf color={color} gradientColor={gradientColor} />
                  <UpperLight color={color} />
                  <div
                    style={{
                      position: "relative",
                      display: "flex",
                      alignItems: "flex-end",
                    }}
                  >
                    {unitImage && !isSticker && (
                      <img
                        src={unitImage}
                        style={{ objectFit: "contain", zIndex: 1 }}
                        alt={"Product"}
                      />
                    )}
                  </div>
                  {showDoor && <Rect src={handle} />}
                  {/*{showDoor && <Pin frameColor={colorUnit || frameColor} />}*/}
                  {/*{showDoor && <PinTop frameColor={colorUnit || frameColor} />}*/}
                </InnerWrapper>
              </Wrapper>
              {/*{showRightDivider && <DividerVertical size={size} />}*/}
            </Box>
            <WhiteBackground
              style={{
                opacity: !popupItem ? 0 : popupItem.id === item.id ? 0 : 0.5,
              }}
            />
          </div>
          <DividerHorizontal />
        </Box>
      }
      flowing
    >
      <PopUpItem item={item} quantity={quantity} />
    </Popup>
  );
};

const Box = styled.div`
  display: flex;
  position: relative;
  flex-direction: column;
`;

const WhiteBackground = styled.div`
  position: absolute;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  background-color: white;
  z-index: 100;
  transition: all 300ms ease-in-out;
`;

const Wrapper = styled.div`
  z-index: 4;
  width: 180px; //166px;
  height: ${({ size }) => size}px;
  //border: 7px solid ${({ frameColor }) => frameColor};
  align-items: center;
  justify-content: center;
  position: relative;
  display: flex;
  border-radius: 2px;
`;

const InnerWrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  position: relative;
  box-shadow: ${({ showDoor }) =>
    showDoor ? "inset 2px 2px 10px 5px rgba(0,0,0,0.16)" : null};
  background-image: linear-gradient(
    to bottom,
    ${({ color }) => color},
    ${({ gradientColor }) => gradientColor} 95%
  );
`;

const Shelf = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 14px;
  background-image: linear-gradient(to bottom, #efe8de, #efe8de 65%);
  z-index: 0;
`;

const UpperLight = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 35px;
  background-image: linear-gradient(
    rgba(255, 255, 255, 0.51),
    rgba(254, 255, 253, 1),
    rgba(253, 254, 251, 0.26),
    rgba(253, 254, 249, 0.08),
    rgba(255, 255, 255, 0),
    rgba(255, 255, 255, 0)
  );
  z-index: 0;
  opacity: 0.6;
`;

const Rect = styled.img`
  position: absolute;
  top: 2px;
  left: 0;
  width: 42px;
  height: 25px;
  z-index: 10;
`;
const DividerHorizontal = styled.div`
  width: 180px;
  height: 18px;
  background-image: linear-gradient(to bottom, #f6f3ee, #f9f3e9);
  border-top: #f7f7f7 1px solid;
  //align-self: center;
`;

export { UnitBox };
